export { ENV_PROP_FIXTURE, USER_PROP_FIXTURE } from '@eb/site-header';

export const FOOTER_LINKS_PROP_FIXTURE = {
    popularSearches: [],
    eventsToPlan: [],
    thirdFooterColumn: [],
    thirdFooterColumnName: 'Find Events',
    countries: [
        {
            locale: 'es_AR',
            locale_name: 'Argentina',
            href: 'http://www.evbdev.com.ar',
            tld: '.com.ar',
        },
        {
            locale: 'en_AU',
            locale_name: 'Australia',
            href: 'http://www.evbdev.com.au',
            tld: '.com.au',
        },
        {
            locale: 'nl_BE',
            locale_name: 'België',
            href: 'http://www.evbdev.be',
            tld: '.be',
        },
        {
            locale: 'fr_BE',
            locale_name: 'Belgique',
            href: 'http://www.evbdev.be/fr_BE/',
            tld: '.be',
        },
        {
            locale: 'pt_BR',
            locale_name: 'Brasil',
            href: 'http://www.evbdev.com.br',
            tld: '.com.br',
        },
        {
            locale: 'en_CA',
            locale_name: 'Canada (EN)',
            href: 'http://www.evbdev.ca',
            tld: '.ca',
        },
        {
            locale: 'fr_CA',
            locale_name: 'Canada (FR)',
            href: 'http://www.evbdev.ca/fr_CA/',
            tld: '.ca',
        },
        {
            locale: 'es_CL',
            locale_name: 'Chile',
            href: 'http://www.evbdev.es',
            tld: '.cl',
        },
        {
            locale: 'es_CO',
            locale_name: 'Colombia',
            href: 'http://www.evbdev.es',
            tld: '.co',
        },
        {
            locale: 'de_DE',
            locale_name: 'Deutschland',
            href: 'http://www.evbdev.de',
            tld: '.de',
        },
        {
            locale: 'es_ES',
            locale_name: 'España',
            href: 'http://www.evbdev.es',
            tld: '.es',
        },
        {
            locale: 'fr_FR',
            locale_name: 'France',
            href: 'http://www.evbdev.fr',
            tld: '.fr',
        },
        {
            locale: 'en_HK',
            locale_name: 'Hong Kong',
            href: 'http://www.evbdev.hk',
            tld: '.hk',
        },
        {
            locale: 'en_IE',
            locale_name: 'Ireland',
            href: 'http://www.evbdev.ie',
            tld: '.ie',
        },
        {
            locale: 'it_IT',
            locale_name: 'Italia',
            href: 'http://www.evbdev.it',
            tld: '.it',
        },
        {
            locale: 'es_MX',
            locale_name: 'Mexico',
            href: 'http://www.evbdev.es',
            tld: '.com.mx',
        },
        {
            locale: 'nl_NL',
            locale_name: 'Nederland',
            href: 'http://www.evbdev.nl',
            tld: '.nl',
        },
        {
            locale: 'en_NZ',
            locale_name: 'New Zealand',
            href: 'http://www.evbdev.co.nz',
            tld: '.co.nz',
        },
        {
            locale: 'de_AT',
            locale_name: 'Österreich',
            href: 'http://www.evbdev.at',
            tld: '.at',
        },
        {
            locale: 'es_PE',
            locale_name: 'Peru',
            href: 'http://www.evbdev.es',
            tld: '.pe',
        },
        {
            locale: 'pt_PT',
            locale_name: 'Portugal',
            href: 'http://www.evbdev.pt',
            tld: '.pt',
        },
        {
            locale: 'en_SG',
            locale_name: 'Singapore',
            href: 'http://www.evbdev.sg',
            tld: '.sg',
        },
        {
            locale: 'en_GB',
            locale_name: 'United Kingdom',
            href: 'http://www.evbdev.co.uk',
            tld: '.co.uk',
        },
        {
            locale: 'en_US',
            locale_name: 'United States',
            href: 'http://www.evbdev.com',
            tld: '.com',
        },
    ],
};
